import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AuthService } from '../../../services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { ModalService } from '../../../services/modal.service';
import { Company } from '../../../models/company';
import { Page } from '../../../models/paging/page';
import { InspectionService } from '../../../services/inspection.service';

@Component({
  selector: 'app-import-inspections',
  templateUrl: './import-inspections.component.html',
  styleUrls: ['./import-inspections.component.scss']
})
export class ImportInspectionComponent implements OnInit {
   loading: boolean = false;
   companyyId: any;
   company_Id: any;
   technicianId: any;
   importFile = {
     fileData: "",
     company_Id: "",
     technicianId: ""
   }

   disableCompany: boolean = false;
   readOnly: boolean = false;
   rows = [];
   page = new Page();
   company: Company;
   user;
   companyName: string = '';
   refetchCompanies: boolean = false;

  constructor(private authService: AuthService, private snotifyService: SnotifyService, public router: Router, private modalService: ModalService, 
    public inspectionService: InspectionService) {
    this.user = this.authService.currentUser.value;
  }

  ngOnInit(): void {

  }

 upload(): void {
  if(this.company_Id == undefined){
    this.snotifyService.error("Please Select a company");
    return;
  }
  if(this.technicianId == undefined){
    this.snotifyService.error("Please Select the technician");
    return;
  }
  console.log(this.importFile);
  if(this.importFile == undefined || this.importFile.fileData == undefined|| this.importFile.fileData == ''){
    this.snotifyService.error("Please Select a File to upload");
    return;
  }
   this.importFile.company_Id = this.company_Id;
   this.importFile.technicianId = this.technicianId;
   this.loading = true;
   console.log(this.importFile);

   this.inspectionService.postMassUpload(this.importFile).then((data) => {
     this.snotifyService.success("Successfully uploaded items");
     this.loading = false;
     this.back();
   }, (err) => {
     console.log(err);
     this.snotifyService.error(err.error);
     this.loading = false;
     this.importFile.fileData = null;
   });
 }

  onCompanyChange(c): void {
    console.log(c);
    if (c != undefined) {
      this.company_Id = c.id;
    } else {
      this.company_Id = undefined;
    }
}
  onTechnicianChange(c): void {
    console.log(c);
    if (c != undefined) {
      this.technicianId = c.id;
    } else {
      this.technicianId = undefined;
    }
}

  uploadFile(e): void {
    var rawBase64 = null;
    var base64 = null;

    // If a file was selected
    if (e.target.files.length > 0) {

      let file = e.target.files[0];
      var reader = new FileReader();

      reader.readAsDataURL(file);

      // Split the initial data type string from the base64 data
      reader.onload = (e) => {
        rawBase64 = reader.result;
        base64 = rawBase64.split(",", 2);
        this.importFile.fileData = base64[1];
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    }
  }

  back() {
   this.router.navigate(['']);
  }
}
